import { AxiosResponse } from 'axios';
import { api } from '../api';
import { StandardResponse } from '../interfaces/Common';
import { User } from '../interfaces/User';

export async function getUserProfile(): Promise<StandardResponse<User>> {
    const response: AxiosResponse<StandardResponse<User>> = await api.get("/preboard/me");
    return response.data;
}

export async function updateProfile(user: Partial<{
    firstName: string;
    lastName: string;
    birthDate: string;
    school: string;
    suffix: string;
}>): Promise<StandardResponse<User>> {
    const response: AxiosResponse<StandardResponse<User>> = await api.put("/preboard/me", user);
    return response.data;
}

export async function firstTimeLogin(user: {
    suffix: string;
    birthDate: string;
    school: string;
    password: string;
}): Promise<StandardResponse<any>> {
    const response: AxiosResponse<StandardResponse<User>> = await api.post("/preboard/me", user);
    return response.data;
}

export async function setTourCompleted(): Promise<StandardResponse<User>> {
    const response: AxiosResponse<StandardResponse<User>> = await api.get("/preboard/me/tour");
    return response.data;
}
